import firebase from 'firebase'

export const  handleLogout = () =>{
    firebase.auth().signOut().then(() => {
  }).catch(err => {
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/Logout.js